'use client';

import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { Avatar } from '@pickleballinc/ui/components/ui/avatar';

import { WORLD_PICKLEBALL_RANKINGS } from '@/modules/rankings/constants';
import { RankingPlayerProfileData } from '@/modules/rankings/ppr/types';

interface ProfileCardProps {
  playerProfileData: RankingPlayerProfileData;
}

export function ProfileCard({ playerProfileData }: ProfileCardProps) {
  return (
    <div className='flex items-center justify-center bg-white py-2'>
      <div className='w-full bg-white border border-gray-200 rounded-[20px] p-2 flex items-center'>
        <div className='relative flex-shrink-0 ml-2'>
          <Avatar
            name={playerProfileData.fullName}
            src={
              playerProfileData.profileImage
                ? getCDNURL(playerProfileData.profileImage, 80, 80)
                : undefined
            }
            size='2xl'
            className='border border-gray-200 bg-gray-100'
            textClassName='text-gray-500'
          />
        </div>
        <div className='md:ml-6 ml-2 flex min-w-0 flex-1 flex-col justify-center'>
          <h1 className='md:text-2xl text-lg font-semibold text-gray-900 leading-tight mb-2'>
            {playerProfileData.fullName.length > 26
              ? playerProfileData.fullName.slice(0, 26) + '...'
              : playerProfileData.fullName}
          </h1>
          <div className='flex md:flex-row flex-col md:items-center items-start text-sm text-gray-700 font-medium md:whitespace-nowrap gap-2 md:gap-0'>
            <div className='flex items-center'>
              {playerProfileData.countryFlag !== '' &&
                playerProfileData.countryAbbreviation !== '' && (
                  <>
                    <div className='w-6 h-6 mr-2 rounded-full overflow-hidden flex items-center justify-center border border-gray-100'>
                      <img
                        src={playerProfileData.countryFlag}
                        alt={`${playerProfileData.fullCountry} Flag`}
                        className='size-5'
                      />
                    </div>
                    <span className='uppercase'>{playerProfileData.countryAbbreviation}</span>
                  </>
                )}
              {playerProfileData.countryFlag !== '' &&
              playerProfileData.countryAbbreviation !== '' &&
              playerProfileData.typeOfPlayer ? (
                <span className='mx-2'>|</span>
              ) : null}
              {playerProfileData.typeOfPlayer ? (
                <span className='uppercase'>{playerProfileData.typeOfPlayer}</span>
              ) : null}
            </div>
            <div className='mx-4 h-4 w-[1px] bg-gray-300 md:flex hidden' />
            <div>
              <span className='text-gray-500'>{WORLD_PICKLEBALL_RANKINGS}</span>
              <span className='font-semibold text-gray-900'>{` #${playerProfileData.pprRank}`}</span>
            </div>
            <div className='mx-4 h-4 w-[1px] bg-gray-300 md:flex hidden' />
            <div>
              <span className='text-gray-500'>{`${WORLD_PICKLEBALL_RANKINGS} Points`}</span>
              <span className='font-semibold text-gray-900'>{` ${Math.round(playerProfileData.pprPointsTotal)}`}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
